import type { SVGProps } from 'react';
const SvgErrorToast = (props: SVGProps<SVGSVGElement>) => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99998 1.00002L1 7M0.999975 1L6.99995 6.99998" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>

);
export default SvgErrorToast;
